import { Component, OnInit, NgZone } from '@angular/core';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { AlertService } from '../services/alert.service';
import { ReportsService } from '../reports/reports.service';
import { VMwareProducts } from '../models/vmwareproducts';
import { ProductReleases } from '../models/productreleases';
import { Observable } from 'rxjs/Rx';
import { Subscription } from 'rxjs/Subscription';
import { MaximumCategory } from '../models/maximumcategory';
import { MaximumSubCategory } from '../models/maximumsubcategory';
import { ElementData } from '../models/elementdata';
import { ConfigMaxSet } from '../models/configmaxset';
import { forEach } from '@angular/router/src/utils/collection';
import { LimitsService } from '../limits/limits.service';
import { CategoryDataRecord } from '../models/categorydatarecord';
import { CategoriesRecord } from '../models/categoriesrecord';
import { PDFGenerator } from "../common/pdf/pdfgenerator";
import { Location } from '@angular/common';
import { NumberConstants } from "../common/numberconstants";
import { Globals } from 'app/common/globals';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentsService } from 'app/services/enviornment.service';

@Component({
    styleUrls: ['./guest.component.scss'],
    templateUrl: './guest.component.html',
    outputs: ['limitdata : category']
})
export class GuestComponent implements OnInit {
    private subscription: Subscription;
    configHeadingLabel: String;
    currentLocale: string = 'en';
    showLanguage: boolean;
    selectedLanguage: string;
    title: string = "";
    langSub: Subscription;
    collapsible: Boolean = true;
    collapsed: Boolean = false;
    isReports: Boolean = false;
    isReview: Boolean = false;
    isCompare: Boolean = false;
    productsRight: VMwareProducts[];
    versionsRight: ProductReleases[];
    maximumssRight: any[];
    subcategoriesRight: any[];
    maximumids: number[] = new Array();
    maximumSubids: number[] = new Array();
    selectedProduct: number;
    selectedObject: VMwareProducts;
    selectedVersion: any;
    selectedCategory: any;
    selectedSubCategory: any;
    categoryupdated: boolean = false;
    subcategories: any;
    parentCat: any;
    subcategorySelected: any
    products: any;
    versions: any;
    filteredVersions: any;
    maximums: any;
    prodData: ElementData;
    versionData: ElementData;
    versionMaxData: ElementData;
    cloneData: ElementData;
    clonedCategory: any;
    clonedsubcategory: any;
    currentVersionData: ElementData;
    currentDate: ElementData;
    comment: ElementData;
    currentMaximumData: ElementData;
    prodMgr: ElementData;
    addProjectData;
    authCheck: string = localStorage.getItem('currentUser');
    maxCat: number[] = new Array();
    maxSubCat: number[] = new Array();
    configMaxSubAttrs: any;
    maximumName: any;
    p: number = this.numberConstant.ONE;
    splitNames: any;
    expandFlag: boolean = true;
    btnCaption: String;
    loaded: boolean = false;
    totalRec: number;
    allrecords:number;
    itemsPerPage: number = this.numberConstant.SIX;
    page: number = this.numberConstant.ONE;
    allselected = false;
    exportDisabled = false;
    excludeInternal: any;
    userType: boolean = false;
    maxlimitsLength:number = this.numberConstant.SIX;
    comparisionHeaders: any = [
        {
            header: this.globals.limitLabel,
            class: "col-lg-3"
        },
        {
            header: this.globals.descriptionLabel,
            class: "col-lg-3"
        }
    ];
    prodIdx = this.numberConstant.ZERO;
    versionIdx = this.numberConstant.ZERO;
    bookmarkStringArr: any;

    constructor(private zone: NgZone, private alertService: AlertService,
        private reportService: ReportsService, private limitsService: LimitsService,private globals: Globals, private router: Router,
        private pdfGenerator: PDFGenerator, private location: Location,private route: ActivatedRoute,private numberConstant:NumberConstants, private translateService: TranslateService, private envService: EnvironmentsService){
            this.initializeTree();
            this.initializeVriables();
    }

    ngOnInit() {
        this.langSub = this.envService.selectedLanguage$.subscribe((lang)=>{
            this.translateService.setDefaultLang('en')
            this.versions[0].type = this.translateService.instant('selectVersion');
            this.products[0].type = this.translateService.instant('selectProduct');
            this.maximums[0].type = this.translateService.instant('allcategoriesLabel');
            this.comparisionHeaders[0].header = this.translateService.instant('viewLimits.limit');
            this.comparisionHeaders[1].header = this.translateService.instant('viewLimits.description');
            this.btnCaption = this.translateService.instant('viewLimitBtn.collapseAll');
            this.configHeadingLabel= this.translateService.instant('viewLimit.heading');

        });
        this.subscription = this.route.queryParams.subscribe((params: Params) => {
        if (params['vmwareproduct']) {
            this.reportService.selectedBookmarkedprod = params["vmwareproduct"];
            this.reportService.selectedBookmarkedversion = params["release"];
            this.reportService.selectedBookmarkedCategories = params["categories"];
            }
            else{
                this.reportService.selectedBookmarkedprod = this.reportService.selectedprodName;
                this.reportService.selectedBookmarkedversion = this.reportService.selectedverName;
                this.reportService.selectedBookmarkedCategories = "";
            }
        });
        this.reportService.categoriesArray =[];
        this.maxCat = [this.numberConstant.ZERO];
        this.maxSubCat = [this.numberConstant.ZERO];
        this.subscription = this.reportService.notifyObservable$.subscribe((res) => {
            if (res.hasOwnProperty('option') && res.option === 'click') {
                // perform your other action from here
                this.maximumids = this.reportService.maximumsCats1Selected;
                this.maximumSubids = this.reportService.maximumsSubCats1Selected;

            } else if (res.hasOwnProperty('option') && res.option === 'title') {
                this.title = res.value;
                this.reportService.selectedverName = res.value;
                this.maximumids = [];
                this.maximumSubids = [];
                this.maximums = [];
            }

        });
        this.getProductInConfigSet();
    }

    assignArray(type: String, expanded: boolean, rights: any[]): any[] {
        let arr = [{
            type: type,
            expanded: expanded,
            rights: rights,
            selected: false
        }];
        return arr;
    }
    getProductInConfigSet(): void {
        this.reportService.getProducts(null).subscribe(
            vmwareproducts => {
                let filteredProductsRight: Array<any> = [];
                vmwareproducts.forEach(vmwareprod => {
                    if(vmwareprod.support === true) {
                        filteredProductsRight.push(vmwareprod);
                    }
                });
                this.productsRight = filteredProductsRight;
                if (this.productsRight != null && this.productsRight != undefined &&
                    this.productsRight.length > this.numberConstant.ZERO) {
                    this.products.rights = this.productsRight;
                    this.selectedProduct = this.productsRight[this.numberConstant.ZERO].id;
                    this.selectedObject = this.productsRight[this.numberConstant.ZERO];
                    this.reportService.selectedprodID = this.productsRight[this.numberConstant.ZERO].id;
                    this.reportService.selectedprodName = this.productsRight[this.numberConstant.ZERO].rmVmwProduct;
                    var vmwareProducts: VMwareProducts;
                    this.products = this.assignArray(
                        this.translateService.instant('selectProduct'),
                        true,
                        this.productsRight
                    );
                    this.reportService.selectedprodsInCfSet = vmwareproducts;
                    if(this.reportService.selectedBookmarkedprod != undefined) {
                        this.selectedProduct = this.reportService.selectedprodID;
                        for (let i = this.numberConstant.ZERO; i < this.productsRight.length; i++) {
                              if(this.productsRight[i].rmVmwProduct == this.reportService.selectedBookmarkedprod) {
                                  this.prodIdx = i;
                                  this.reportService.selectedprodID = this.productsRight[i].id;
                                  this.reportService.selectedprodName = this.productsRight[i].rmVmwProduct;
                                  this.selectedProduct = this.productsRight[i].id;
                                  this.reportService.selectedBookmarkedprod = "";
                                  break;
                              }
                        }

                    }
                    this.getSelProductVersionsByID();
                }
            },
            err => {
                // Log errors if any
                console.log(err);
            }
        );
    }

    getSelProductVersionsByID(): void {
        this.reportService
            .getProductVersions(this.selectedProduct.toString(), this.numberConstant.HASCONFIGSETANDPUBLISHED)
            .subscribe(
                vmwareproductsVersions => {
                    this.zone.run(() => {
                        // <== added
                        // Filter here
                        let filteredVersionsRight: Array<any> = [];
                        vmwareproductsVersions.forEach(vmwareversion => {
                            if(vmwareversion.support === true) {
                                filteredVersionsRight.push(vmwareversion);
                            }
                        });
                        this.versionsRight = filteredVersionsRight;
                        this.selectedVersion = this.versionsRight[this.numberConstant.ZERO];
                        this.selectedProduct = this.versionsRight[this.numberConstant.ZERO].id;
                        this.reportService.selectedversionID = this.selectedVersion.id;
                        this.versions = this.assignArray(
                            this.translateService.instant('selectVersion'),
                            true,
                            this.versionsRight
                        );
                        if(this.reportService.selectedBookmarkedversion != undefined && this.reportService.selectedBookmarkedversion.length >this.numberConstant.ZERO) {
                            for (let i = this.numberConstant.ZERO; i < this.versionsRight.length; i++) {
                                if(this.versionsRight[i].rmVmwPrdRelVersion  == this.reportService.selectedBookmarkedversion) {
                                    this.versionIdx = i;
                                    this.selectedVersion = this.versionsRight[i];
                                    this.reportService.selectedversionID = this.versionsRight[i].id;
                                    this.reportService.selectedverName = this.versionsRight[i].rmVmwPrdRelVersion;
                                    this.reportService.selectedBookmarkedversion ="";
                                    break;
                                }
                          }
                        }
                        this.reportService.notifyOther({
                            option: "title",
                            value: this.selectedVersion.rmVmwPrdRelVersion
                        });
                        this.getSelProductCategories(
                            this.reportService.selectedprodID,
                            this.reportService.selectedversionID
                        );
                        this.reportService.getSelectedConfigset();
                    });
                }, //Bind to view
                err => {
                    // Log errors if any
                    this.versions = this.assignArray(
                        this.translateService.instant('selectVersion'),
                        true,
                        []
                    );
                    this.maximums = this.assignArray(this.translateService.instant('allcategoriesLabel'), true, []);
                    this.configMaxSubAttrs = [];
                    this.totalRec = this.numberConstant.ZERO;
                    this.loaded = true;
                    console.log(err);
                }
            );
    }

    getSelectedProductVersions(): void {
        this.reportService.getProductVersions(this.selectedProduct.toString(), this.numberConstant.ONE) // Get all product release versions of a given product
            .subscribe(vmwareproductsVersions => {
                this.zone.run(() => { // <== added
                    this.reportService.selectedversions = vmwareproductsVersions;
                });
            }, //Bind to view
                err => {
                    // Log errors if any
                    console.log(err)
                });

    }

    getSelProductCategories(prodid: number, verid: number): void {
        this.loaded = false;
        this.page = this.numberConstant.ONE;
        this.p = this.numberConstant.ONE;
        this.totalRec = this.numberConstant.ZERO;
        this.reportService.getMaximumCategoriesByProductIdAndVersionId(prodid, verid, true)
            .subscribe(vmwareproductsMaximums => {
                this.zone.run(() => { // <== added
                    this.maximumssRight = vmwareproductsMaximums;
                    this.selectedCategory = this.maximumssRight[this.numberConstant.ZERO];
                    this.maximums = this.assignArray(this.translateService.instant('allcategoriesLabel'), true, this.maximumssRight);
                    if (this.reportService.selectedBookmarkedCategories != null &&
                        this.reportService.selectedBookmarkedCategories != undefined &&
                        this.reportService.selectedBookmarkedCategories.length > this.numberConstant.ZERO) {
                        this.reportService.setSelectedCategories("guest?vmwareproduct=" + this.reportService.selectedBookmarkedprod +
                        "&release=" + this.reportService.selectedBookmarkedversion + "&categories=" + this.reportService.selectedBookmarkedCategories,this.maximums[this.numberConstant.ZERO].rights)
                        if( this.reportService.categoriesArray.length >this.numberConstant.SIX) {
                        let categoriesData: CategoriesRecord = this.reportService.getCategorieData(this.reportService.selectedprodID, this.reportService.selectedversionID);
                        this.getCategoriesCount(categoriesData,false);
                       }
                    } else {
                        this.maximums[this.numberConstant.ZERO].rights[this.numberConstant.ZERO].selected = true;
                        this.reportService.categoriesArray = [];
                        this.reportService.addCategatoryData(this.selectedCategory.id);
                    }
                    this.getdata(this.reportService.selectedprodID, this.reportService.selectedversionID);
                });
            }, //Bind to view
                err => {
                    // Log errors if any
                    this.maximums = this.assignArray(this.translateService.instant('allcategoriesLabel'), true, []);
                    this.loaded = true;
                    console.log(err)
                });

    }
    onProdChange(id) {
        let productFiltered = new VMwareProducts();
        this.productsRight.forEach(product => {
            if (product.id == id) {
                productFiltered = product;
            }
        });
        this.selectedProduct = productFiltered.id;
        this.selectedObject = productFiltered;
        this.reportService.selectedprodID = productFiltered.id;
        this.reportService.selectedprodName = productFiltered.rmVmwProduct;
        this.getSelProductVersionsByID();
    }

    onVersionChange(vmwareversionId) {
        let vmwareversion = new ProductReleases();
        this.versionsRight.forEach(version => {
            if (version.id == vmwareversionId) {
                vmwareversion = version;
            }
        });
        this.selectedProduct = vmwareversion.id;
        this.selectedVersion = vmwareversion;
        this.reportService.selectedversionID = this.selectedVersion.id;
        this.reportService.getSelectedConfigset();
        this.reportService.maximumsCats1Selected = [];
        this.reportService.maximumsSubCats1Selected = [];
        this.getSelProductCategories(this.reportService.selectedprodID, this.reportService.selectedversionID);
        this.reportService.notifyOther({
            option: "title",
            value: this.selectedVersion.rmVmwPrdRelVersion
        });

    }

    addToSubCategories(id: number) {
        const found = this.reportService.maximumsSubCats1Selected.indexOf(id);
        if (found == this.numberConstant.MINUS_ONE) {
            this.reportService.maximumsSubCats1Selected.push(id);
            let maxidsnodups = Array.from(new Set(this.reportService.maximumsSubCats1Selected));
            this.reportService.maximumsSubCats1Selected = maxidsnodups;
        }
    }

    updateSelections() {
        this.reportService.categoriesArray = [];
        this.reportService.
            maximumsCats1Selected = [];
        this.reportService.
            maximumsSubCats1Selected = [];
        this.page = this.numberConstant.ONE;
        this.p = this.numberConstant.ONE;
        this.totalRec = this.numberConstant.ZERO;
        this.loaded = false;
        this.maximums[this.numberConstant.ZERO].rights.forEach(element => {
            if (element.selected === true) {
                if (element.child === false || (element.subcategories  && Array.isArray(element.subcategories) && element.subcategories.length == 0)) {
                    this.reportService.addToCategories(element.id);
                    this.reportService.addCategatoryData(element.id);
                } else if (element.child === true) {
                    this.reportService.addToCategories(element.id);
                    this.reportService.addSubcategoriesToRightPanel(element.subcategories, element.id);
                }
            } else {
                if (element.child === false) {
                    this.reportService.
                        maximumsCats1Selected = this.searchItemSelected(this.reportService.
                            maximumsCats1Selected, element.id);
                } else if (element.child === true) {
                    this.reportService.
                        maximumsCats1Selected = this.searchItemSelected(this.reportService.
                            maximumsCats1Selected, element.id);
                    element.subcategories.forEach(elementsub => {
                        if (elementsub.selected === false) {
                            this.reportService.maximumsSubCats1Selected = this.searchItemSelected(this.reportService.
                                maximumsSubCats1Selected, elementsub.id);
                        }
                        if (elementsub.selected === true) {
                            this.reportService.addToCategories(element.id);
                            const found = this.reportService.maximumsSubCats1Selected.indexOf(elementsub.id);
                            if (found == this.numberConstant.MINUS_ONE) {
                                let maxidsnodups = Array.from(new Set(this.reportService.maximumsSubCats1Selected));
                                this.reportService.maximumsSubCats1Selected = maxidsnodups;
                                this.reportService.addSubCateoryData(element.id, elementsub);
                            }
                            if (this.reportService.maximumsCats1Selected == null || this.reportService.maximumsCats1Selected.length == this.numberConstant.ZERO) {
                                this.reportService.maximumsCats1Selected.push(this.numberConstant.ZERO);
                            }
                        }
                    });
                }
            }
        });
        let categoriesData: CategoriesRecord = this.reportService.getCategorieData(this.reportService.selectedprodID, this.reportService.selectedversionID);
        this.getCategoriesCount(categoriesData,false);
    }


    getCategoriesCount(categoriesData: CategoriesRecord, showAll: boolean): number {
        let totalRec = this.numberConstant.ZERO;
        this.limitsService.getConfigMaximums(categoriesData,
            this.numberConstant.ZERO, this.numberConstant.ZERO, showAll,true)
            .subscribe(responseData => {
                if (responseData.ok === true) {
                    let releases = responseData.json();
                    totalRec = releases.length;
                    this.totalRec = totalRec;
                    this.allrecords = totalRec;
                    this.reportService.totalRecords = totalRec;
                    this.getdata(this.reportService.selectedprodID, this.reportService.selectedversionID);
                }
            },
            err => {
                console.log(err);
                totalRec = this.numberConstant.ZERO;
                return this.numberConstant.ZERO;
            });
        return totalRec;
    }
    searchItemSelected(list: any, item): any {
        let maxidsnodups = Array.from(new Set(list));
        list = maxidsnodups;
        const index = list.indexOf(item);
        if (index >= this.numberConstant.ZERO) {
            list.splice(index, this.numberConstant.ONE);
        }
        return list;
    }

    initializeTree() {
        this.products = [
            {
                type: this.translateService.instant('selectProduct'),
                expanded: true,
                rights: []
            }
        ];

        this.versions = [
            {
                type: this.translateService.instant('selectVersion'),
                expanded: true,
                rights: []
            }
        ];
        this.maximums = [
            {
                type: this.translateService.instant('allcategoriesLabel'),
                expanded: true,
                rights: []
            }
        ];
        this.clonedCategory = [
            {
                type: "All Category",
                expanded: true,
                rights: []
            }
        ];
        this.clonedsubcategory = [{
            type: "select sub maximum",
            expanded: true,
            rights: []
        }];

    }
    initializeVriables() {
        this.prodData = ElementData.getproddata(this.translateService.instant('product'), false,this.translateService.instant('enter'),this.translateService.instant('name'));
        this.versionData = ElementData.getselecversiondata(this.translateService.instant('manLimits.version'), false,this.translateService.instant('enter'),this.translateService.instant('name'));
        this.cloneData = ElementData.getclonedata(this.translateService.instant('createNew'),this.translateService.instant('create'),this.translateService.instant('clone'));
        this.currentVersionData = ElementData.getselecversiondata(this.translateService.instant('cloneFromVersion'), true,this.translateService.instant('enter'),this.translateService.instant('name'));
        this.currentDate = ElementData.getCurrentDate(this.translateService.instant('manageRelModal.publishDate'));
        this.comment = ElementData.getDescData(this.translateService.instant('limit.comment'));
        let copyProddata = ElementData.getproddata(this.translateService.instant('cloneFromProd'), true,this.translateService.instant('enter'),this.translateService.instant('name'));
        this.initializeproductData([this.prodData, this.versionData, this.cloneData,
            copyProddata, this.currentDate, this.comment]);
        this.initializeMaximumdata([]);

    }
    initializeMaximumdata(arr: any) {
        let versionData = ElementData.getproddata(this.translateService.instant('manLimits.version'), false, this.translateService.instant('enter'),this.translateService.instant('name'))
        let cloneData = ElementData.getclonedata(this.translateService.instant('createNew'),this.translateService.instant('create'),this.translateService.instant('clone'));
        let clonecatData = ElementData.getclonedataCategories(this.translateService.instant('cloneCategory'), true,this.translateService.instant('enter'),this.translateService.instant('name'));
        clonecatData.options = this.clonedCategory;
        let clonedsubcategory = ElementData.getclonedatasubCategories(this.translateService.instant('cloneSubCat'), true,this.translateService.instant('enter'),this.translateService.instant('name'));
        let newMaxData = ElementData.getVersiondata(this.translateService.instant('newMaxCategory'));
        let newMaxsubData = ElementData.getVersiondata(this.translateService.instant('newMaxSubcategory'));
        this.currentMaximumData = ElementData.getproddata(this.translateService.instant('currentMax'), false, this.translateService.instant('enter'),this.translateService.instant('name'));

        this.prodMgr = ElementData.getVersiondata(this.translateService.instant('manLimits.prodManager'));
        let desc = ElementData.getDescData(this.translateService.instant('viewLimits.description'));
        let maxarr = [this.prodData, versionData, cloneData, clonecatData, clonedsubcategory, newMaxData, newMaxsubData, this.prodMgr, desc];
    }
    getProductArray(array: any, prod, copy, cat): any {
        let arr: any = new Array();
        arr.push({ id: this.numberConstant.ZERO, value: this.translateService.instant('select'), cat: cat, isprod: prod, iscopy: copy });
        if (array != null && array != undefined) {
            array.forEach(element => {
                arr.push({ id: element.id, value: element.rmVmwProduct, cat: cat, isprod: prod, iscopy: copy });
            });
        }
        return arr;
    }
    getCategoryArray(array: any, prod, copy, cat): any {
        let arr: any = new Array();
        arr.push({ id: this.numberConstant.ZERO, value: this.translateService.instant('select'), cat: cat, isprod: prod, iscopy: copy });
        if (array != null && array != undefined) {
            array.forEach(element => {
                arr.push({ id: element.id, value: element.category, cat: cat, isprod: prod, iscopy: copy });
            });
        }
        return arr;
    }
    initializeproductData(elementsarr: any) {
        this.addProjectData = {
            state: false,
            backdrop: true,
            title: this.translateService.instant('newMaximumSet'),
            subTitle: "",
            cancelButton: this.translateService.instant('cancel'),
            okButton: this.translateService.instant('create'),
            cancelBClass: "btn-outline",
            okBClass: "btn-success",
            elements: elementsarr,
            isMaximum: false
        };
    }
    pageChanged(event) {
        this.p = event;
        this.page = event;
        this.loaded = false;
        this.configMaxSubAttrs = [];
        this.reportService.totalRecords = this.allrecords;
        this.getdata(this.reportService.selectedprodID, this.reportService.selectedversionID);
    }

    expandAll() {
        if (this.expandFlag == true) {
            this.expandFlag = false;
            this.btnCaption = this.translateService.instant('expandAll');
        } else {
            this.expandFlag = true;
            this.btnCaption = this.translateService.instant('viewLimitBtn.collapseAll');
        }
    }

    gettotalCounts(selectAll: boolean): number {
        let count = this.numberConstant.ZERO;
        this.maximums[this.numberConstant.ZERO].rights.forEach(element => {
            if (selectAll === true) {
                element.selected = true;
            }
            if (element.selected === true) {
                if (element.child === false) {
                    count = count + this.numberConstant.ONE;
                } else if (element.child === true) {
                    count = count + element.subcategories.length;
                }
            }
        });
        return count;

    }

    getdata(prodid: number, verid: number): void {
        if (this.reportService.categoriesArray == null || this.reportService.categoriesArray.length == this.numberConstant.ZERO) {
            this.alertService.warn(this.translateService.instant('selectMaximum'));
            window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_10000);
            this.loaded = true;
            this.configMaxSubAttrs = [];
            return;
        }
        this.totalRec = this.reportService.totalRecords;
        let categoriesData: CategoriesRecord = this.reportService.getCategorieData(prodid, verid);
        this.limitsService.getConfigMaximums(categoriesData,
            this.page, this.itemsPerPage, false,false)
            .subscribe(responseData => {
                if (responseData.ok === true) {
                    let releases = responseData.json();
                    for (let release of releases) {
                        this.maximumName = release.name;
                        this.splitNames = this.maximumName.split(":")
                        release.names = this.splitNames;
                    }
                    this.loaded = true;
                    this.configMaxSubAttrs = releases;
                }
                this.reportService.onBookMark("/guest",true,false,true);
            },
                err => {
                    console.log(err)
                    this.loaded = true;
                    this.totalRec = this.numberConstant.ZERO;
                    this.alertService.warn(this.translateService.instant('noMaximumsFound'));
                    window.setTimeout(() => this.alertService.clear(),this.numberConstant.ALERT_DELAY_5000);
                });
    }

    exportGuest(): void {
        this.exportDisabled = true;
        this.maximums[this.numberConstant.ZERO].rights.forEach(element => {
            if (element.child === false || (element.subcategories  && Array.isArray(element.subcategories) && element.subcategories.length == 0)) {
                this.reportService.addToCategories(element.id);
                this.reportService.addCategatoryData(element.id);
            } else if (element.child === true) {
                this.reportService.addToCategories(element.id);
                this.reportService.addSubcategoriesToRightPanel(element.subcategories, element.id);
            }
        });
        this.alertService.success(this.translateService.instant('revPubl.downloadMsg'));
        window.setTimeout(() => this.alertService.clear(), this.numberConstant.ALERT_DELAY_8000);
        let categoriesData: CategoriesRecord = new CategoriesRecord();
        categoriesData.prodId = this.reportService.selectedprodID;
        categoriesData.relId =  this.reportService.selectedversionID;
        categoriesData.categories = this.reportService.categoriesArray;
        this.limitsService.getConfigMaximums(categoriesData, this.numberConstant.ZERO, this.numberConstant.ZERO, this.userType,false)
            .subscribe(responseData => {
                if (responseData.ok === true) {
                    let releases = responseData.json();
                    for (let release of releases) {
                        let maximumName = release.name;
                        let splitNames = maximumName.split(":")
                        release.names = splitNames;
                    }
                    this.pdfGenerator.pdfGenerate(releases, this.reportService.selectedConfigSet.publishedDate,
                        this.reportService.selectedverName, this.selectedVersion.rmVmwPrdRelVersion,
                        this.selectedVersion.rmVmwPrdRelGADate, this.userType, this.excludeInternal);
                    this.exportDisabled = false;
                }
            },
                err => {
                    console.log(err)
                    this.loaded = true;
                    this.totalRec = this.numberConstant.ZERO;
                    this.exportDisabled = false;
                    this.alertService.warn(this.translateService.instant('noMaximums'));
                    window.setTimeout(() => this.alertService.clear(),this.numberConstant.ALERT_DELAY_5000);
                });
    }

    checkIsEnabled() {
        return this.exportDisabled;
    }

    updateSelectedLang(){
        if(localStorage.getItem('configmax-lang') === null || localStorage.getItem('configmax-lang') === 'en'){
            this.selectedLanguage = 'English'
          }
          else if(localStorage.getItem('configmax-lang') === 'ja'){
            this.selectedLanguage = '日本語'
          }
          else if(localStorage.getItem('configmax-lang') === 'zh'){
              this.selectedLanguage = ' 中文'
            }
          this.envService.selectedLang = this.selectedLanguage;
          this.envService.selectedLanguage.next(this.selectedLanguage);
    }

    changeLanguage(lang: string) {
        this.translateService.use(lang);
        this.showLanguage = false;
        localStorage.setItem('configmax-lang', lang);
        this.updateSelectedLang();
      }

      onLanguageClick(){
        this.showLanguage = true;
      }

      onCancelClick(){
        this.showLanguage = false;
      }

}


// WEBPACK FOOTER //
// ./src/app/guest/guest.component.ts